import { Navigate } from 'react-router-dom';
import Loader from '@/components/ui/loader';
const ProtectedAdminRoutes = ({
  children,
  allowed,
  isLoading = false,
}: {
  children: React.ReactNode;
  allowed: boolean;
  isLoading?: boolean;
}) => {
  // Wait for the user's role before deciding, otherwise a page refresh redirects away
  if (isLoading) return <Loader />;
  if (!allowed) return <Navigate to="/dashboard" replace />;
  return children;
};

export default ProtectedAdminRoutes;
